export default __webpack_public_path__ + "static/perfect90-82c695fa10be402df542a63841a7685f.png";